<template>
    <div>            
        <div class='dataContainer' >
            <ul class="list-group">
                <li class="list-group-item list-group-item-warning" v-show='gotData' >
                    <div class="row">
                        <div class="col-xs-12 col-md-3" >  
                            <span class='IndexWidth mobileText'>#</span>
                            <span class='mobileText'>Nombre:&nbsp;&nbsp;&nbsp;<input v-model='filteredItemsDetail' class='NameHeader' >&nbsp;<span class='glyphicon glyphicon-search glyphiconSize' ></span></span>
                        </div>
                        <div class="hidden-sm col-md-7" >  
                            <span class='Phone mobileText' >Telefono</span>                        
                            <span class='Cedula mobileText' >Cedula</span>                        
                            <span class='Date mobileText' >Fecha</span>                        
                        </div>
                        <div class="hidden-sm col-md-2" >  
                            <span class='btnWidth mobileText' >Detalles</span>                    
                            <span class='btnWidth mobileText' >Borrar</span>                    
                        </div>
                    </div>
                </li>                
                <li class="list-group-item" v-for='(itemsDetail, index) in filteredItemsDetails' v-if='index < maxItemToShow' >                      
                    <div class="row">          
                        <div class="col-xs-9 col-md-3" >  
                            <span  class='IndexWidth mobileText' >{{ index+1 }}</span>
                            <span> <input class='Name form-control'  type='text' readonly="readonly" v-model='itemsDetail.completeName'></span>
                        </div>
                        <div class="hidden-sm col-md-7" >  
                            <span> <input class='Phone form-control'  type='text' readonly="readonly" v-model='itemsDetail.phone1'></span>                                        
                            <span> <input class='Cedula form-control' type='text' readonly="readonly" v-model='itemsDetail.cedula'></span>                           
                            <span> <input class='Date form-control'   type='text' readonly="readonly" v-model='itemsDetail.formattedAddedDate'></span>                           
                        </div>
                        <div class="col-xs-3 col-md-2" >  
                            <span  class='btnWidth' ><button type="button"   v-bind:class="itemsDetail.showDetails ? classUpArrow : classDownArrow" @click='detailsRow(itemsDetail)' ></button></span>                                                              
                            <span  class='btnWidth' ><button type="button"   class="btn btn-danger glyphicon glyphicon glyphicon-remove glyphiconSize" @click='deleteRow(itemsDetail)' ></button></span>                        
                        </div>
                    </div>                    
                    <div v-show='itemsDetail.showDetails' >
                        <hr>                        
                        <div class="panel panel-primary">
                            <div class="panel-heading">Informacion del cliente</div>
                            <div class="panel-body">                                
                                <div class="row">         
                                    <div class="col-xs-12 col-md-12" >   
                                        <div class="input-group form-group fillRow">
                                            <span class="input-group-addon">Nombre completo</span>
                                            <input type="text"  class="form-control text-right" readonly="readonly" v-model='itemsDetail.completeName' >
                                        </div>
                                    </div>
                                </div>
                                <div class="row">         
                                    <div class="col-xs-12 hidden-md" >   
                                        <div class="input-group form-group fillRow">
                                            <span class="input-group-addon">Fecha:</span>
                                            <input type="text"  class="form-control text-right" readonly="readonly" v-model='itemsDetail.formattedAddedDate' >
                                        </div>
                                    </div>
                                </div>
                                <div class="row">         
                                    <div class="col-xs-12 col-md-12" >   
                                        <div class="input-group form-group fillRow">
                                            <span class="input-group-addon">E-Mail</span>
                                            <input type="text" class="form-control text-right" readonly="readonly" v-model='itemsDetail.email' >
                                        </div>
                                    </div>
                                </div>
                                <div class="row">         
                                    <div class="col-xs-12 col-md-4" >   
                                        <div class="input-group form-group">
                                            <span class="input-group-addon">Telefono</span>
                                            <input type="text" class="form-control text-right" readonly="readonly" v-model='itemsDetail.phone1' >
                                        </div>
                                    </div>
                                    <div class="col-xs-12 col-md-4" >   
                                        <div class="input-group form-group">
                                            <span class="input-group-addon">Cedula</span>
                                            <input type="text" class="form-control text-right" readonly="readonly" v-model='itemsDetail.cedula' >
                                        </div>
                                    </div>
                                    <div class="col-xs-12 col-md-4" >   
                                        <div class="input-group form-group">
                                            <span class="input-group-addon">Tipo de persona</span>
                                            <input type="text" class="form-control text-right" readonly="readonly" v-model='itemsDetail.type_of_person' >
                                        </div>
                                    </div>       
                                </div>                                    
                            </div>
                        </div>

                        <div class="panel panel-primary">
                            <div class="panel-heading">Informacion del vehiculo</div>
                            <div class="panel-body">
                                <div class="row">          
                                    <div class="col-xs-12 col-md-4" >  
                                        <div class="input-group form-group">
                                            <span class="input-group-addon">Marca</span>
                                            <input type="text" class="form-control text-right" readonly="readonly" v-model='itemsDetail.car_brand_name' >
                                        </div>
                                    </div>
                                    <div class="col-xs-12 col-md-4" >  
                                        <div class="input-group form-group">
                                            <span class="input-group-addon">Modelo</span>
                                            <input type="text" class="form-control text-right" readonly="readonly" v-model='itemsDetail.car_model' >
                                        </div>
                                    </div>
                                    <div class="col-xs-12 col-md-4" >                              
                                        <div class="input-group form-group">
                                            <span class="input-group-addon">Año</span>
                                            <input type="text" class="form-control text-right" readonly="readonly" v-model='itemsDetail.model_year' >
                                        </div>
                                    </div>
                                </div>                                
                            </div>
                        </div>
                        <div class="panel panel-primary">
                            <div class="panel-heading">Informacion financiera</div>
                            <div class="panel-body">
                                <div class="row">          
                                    <div class="col-xs-12 col-md-4" >  
                                        <div class="input-group form-group">
                                            <span class="input-group-addon">Banco</span>
                                            <input type="text" class="form-control text-right" readonly="readonly" v-model='itemsDetail.bank_name' >
                                        </div>
                                    </div>
                                    <div class="col-xs-12 col-md-4" >  
                                        <div class="input-group form-group">
                                            <span class="input-group-addon">Tasa De interes</span>
                                            <input type="text" class="form-control text-right" readonly="readonly" v-model='itemsDetail.interest_rate' >
                                        </div>
                                    </div>
                                    <div class="col-xs-12 col-md-4" >  
                                        <div class="input-group form-group">
                                            <span class="input-group-addon">Finaciamiento en meses</span>
                                            <input type="text" class="form-control text-right" readonly="readonly" v-model='itemsDetail.finance_length_months' >
                                        </div>
                                    </div>
                                </div>
                                <div class="row">          
                                    <div class="col-xs-12 col-md-4" >                                      
                                        <div class="input-group form-group">
                                            <span class="input-group-addon">Valor del vehículo</span>
                                            <input type="text" class="form-control text-right" readonly="readonly" v-model='itemsDetail.total_car_price' >
                                        </div>
                                    </div>
                                    <div class="col-xs-12 col-md-4" >                                      
                                        <div class="input-group form-group">
                                            <span class="input-group-addon">Inicial</span>
                                            <input type="text" class="form-control text-right" readonly="readonly" v-model='itemsDetail.initial_payment' >
                                        </div>
                                    </div>
                                    <div class="col-xs-12 col-md-4" >  
                                        <div class="input-group form-group">
                                            <span class="input-group-addon">Agregado al inicial</span>
                                            <input type="text" class="form-control text-right" readonly="readonly" v-model='itemsDetail.initial_payment_added' >
                                        </div>
                                    </div>
                                </div>
                                <div class="row">          
                                    <div class="col-xs-12 col-md-4" >                                      
                                        <div class="input-group form-group">
                                            <span class="input-group-addon">Monto a financiar </span>
                                            <input type="text" class="form-control text-right" readonly="readonly" v-model='itemsDetail.finance_amount' >
                                        </div>
                                    </div>
                                    <div class="col-xs-12 col-md-4" >  
                                        <div class="input-group form-group">
                                            <span class="input-group-addon">Mensualidad</span>
                                            <input type="text" class="form-control text-right" readonly="readonly" v-model='itemsDetail.monthly_payments_amount' >
                                        </div>
                                    </div>
                                    <div class="col-xs-12 col-md-4" >                                      
                                        <div class="input-group form-group">
                                            
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="panel panel-primary" v-show='itemsDetail.tasar_old_car' >
                            <div class="panel-heading ">Vehiculo a tasar</div>
                            <div class="panel-body">
                                <div class="row">          
                                    <div class="col-xs-12 col-md-4" >                                      
                                        <div class="input-group form-group">
                                            <span class="input-group-addon">Marca</span>
                                            <input type="text" size="10" class="form-control text-right" readonly="readonly" v-model='itemsDetail.old_car_brand_name' >
                                        </div>
                                    </div>
                                    <div class="col-xs-12 col-md-4" >  
                                        <div class="input-group form-group">
                                            <span class="input-group-addon">Modelo</span>
                                            <input type="text" size="10" class="form-control text-right" readonly="readonly" v-model='itemsDetail.old_car_model' >
                                        </div>
                                    </div>
                                    <div class="col-xs-12 col-md-4" >  
                                        <div class="input-group form-group">
                                            <span class="input-group-addon">Año</span>
                                            <input type="text" size="10" class="form-control text-right" readonly="readonly" v-model='itemsDetail.old_car_year' >
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <hr>
                    </div>                    
                </li>        
            </ul>
        </div>
        <Pagination v-bind:pagesInfo='pagesInfo' ></Pagination>
    </div>
</template>

<script>
import { eventBus } from '../../main';
import { PaginationMixin } from '../mixin/PaginationMixin';

export default {  
  mixins : [PaginationMixin],
  data: function () {     
    return {
        classDownArrow: 'btn btn-info glyphicon glyphicon-chevron-down glyphiconSize',
        classUpArrow: 'btn btn-info glyphicon glyphicon-chevron-up glyphiconSize',
        ItemsDetails: [],
        filteredItemsDetail: '',
        gotData: false,  
        maxItemToShow: 12,
        pagesInfo:[],            
    }
  },
  mounted: function () {        
       this.getItemsDetails();  
       this.getPaginationLinks('/admin/inquiryadmin/','api/getinquirycount', this.maxItemToShow);
  },
  watch: { // whenever question changes, this function will run        
    $route () {                
        this.getItemsDetails();                
    }
  },
  methods: {
    updateParams : function() {
        if(this.$route.params.offset)
            this.offset = this.$route.params.offset;    
        else
            this.offset = 0;     
    },
    getItemsDetails: function() {         

        this.updateParams();           

        var callUrl = 'api/carinquiry/maxresult/' + this.maxItemToShow + '/offset/' +  this.offset;
        
        this.$http.get(callUrl).then(response => {           
            this.ItemsDetails = response.body.map(obj =>{
                                
                obj.completeName = obj.first_name + ' ' + obj.last_name;
                var addedDate = new Date(obj.added_date);
                //obj.formattedAddedDate = addedDate.getDate() + '-' + addedDate.getMonth() + '-' +  addedDate.getFullYear() + ' ' +  addedDate.getHours() + ':' +  addedDate.getMinutes() + ':' +  addedDate.getSeconds();                
                obj.formattedAddedDate = addedDate.toLocaleString();
                obj.total_car_price         = this.getMoneyVal(obj.currency_name,obj.total_car_price);
                obj.initial_payment         = this.getMoneyVal(obj.currency_name,obj.initial_payment);
                obj.initial_payment_added   = this.getMoneyVal(obj.currency_name,obj.initial_payment_added);
                obj.finance_amount          = this.getMoneyVal(obj.currency_name,obj.finance_amount);
                obj.monthly_payments_amount = this.getMoneyVal(obj.currency_name,obj.monthly_payments_amount);

                if(obj.type_of_person == 1)
                    obj.type_of_person = 'Empresa';
                else 
                    obj.type_of_person = 'Persona';                

                if(obj.tasar_old_car == 1)
                    obj.tasar_old_car = true;
                else
                    obj.tasar_old_car = false;

                obj.showDetails = false;
                return obj;
            });
            this.gotData = true;            
        }, response => {
           eventBus.$emit('errorMsg',response);   
        });
    },
    detailsRow: function(itemsDetail){
        itemsDetail.showDetails = !itemsDetail.showDetails;        
    },    
    deleteRow: function({id})
    {                        
        this.$http.delete('api/carinquiry/' + id).then(response => {                                    
            eventBus.$emit('resultMessage',response);           
            this.getItemsDetails();
        }, response => {
            eventBus.$emit('errorMsg',response);
        });
    },
    getMoneyVal(currency_name, value) {
        return currency_name + ':' + this.addCommas(value.toFixed(2)); //'9,999,999.00'
    },
    addCommas: function (str) {
        return (str + "").replace(/\b(\d+)((\.\d+)*)\b/g, function(a, b, c) {
            return (b.charAt(0) > 0 && !(c || ".").lastIndexOf(".") ? b.replace(/(\d)(?=(\d{3})+$)/g, "$1,") : b) + c;
        });
    }
  },
  filters: {
     
  },
  computed: {
    filteredItemsDetails: function() {        
        return this.ItemsDetails.filter((element) => {               
            return element.first_name.toLowerCase().match(this.filteredItemsDetail.toLowerCase());
        });
    }      
  }
}
</script>

<style scoped>
   .dataContainer{
       width:850px;
       margin-left: 50px;              
   }

   .btnWidth{
        width:38%;        
        display:inline-block;      
   }
   .IndexWidth {
        display:inline-block;
        width:10%;
        padding-left: 10px;
        margin-right: 10px;
   }

   .NameHeader {
        display:inline-block;
        width:45%;
   }

  .Name {
        display:inline-block;
        width:80%;
   }

   .Phone {
        margin-left: 15px;
        display:inline-block;
        width:120px;
   }

   .Email {
        margin-left: 15px;
        display:inline-block;
        width:200px;
   }

   .Cedula {
        margin-left: 15px;
        display:inline-block;
        width:120px;
   }

   .Date {
        margin-left: 15px;
        display:inline-block;
        width:180px;
   }   
 
   .fillRow{
        width: 100%;    
   }      

   .col-md-2 {
       padding-left: 0px;
       padding-right: 0px;
   }
   .col-md-3 {
       padding-right: 0px !important;
   }

   .col-md-4:not(:first-child) {
       padding-left: 0px !important;
   }

   .col-md-7 {
       padding-left: 0px;
       padding-right: 0px;
   }

    @media screen and (max-width: 981px) { 

        .btnWidth {        
            margin-left: 10px;          
        }

        input {        
            position:relative;
            width:100%;
            height:75px;
            font-size: 2.4em;            
        }

        .NameHeader {
            display:inline-block;
            width:50%;
            font-size: 1em;
        }

        select {        
            position:relative;
            width:100%;
            height:100px;
            font-size: 2em;            
        }

        .input-group-addon {                    
            font-weight: 200;
            font-size: 3em;                        
        }

        button {                    
            position:relative;
            width:80px;
            height:80px;
            font-size: 2.5em;            
        }

        .mobileText {
            font-size: 3em;            
        }

        .panel-heading {                    
            font-weight: 200;
            font-size: 3em;                        
        }

        .col-xs-12 {
            margin-left: 15px;
            padding-left: 0px;
            padding-right: 30px;
        }

     
   }

</style>



// WEBPACK FOOTER //
// InquiryAdmin.vue?0915f5b3